import { registerDestructor } from '@ember/destroyable';
import { waitForPromise } from '@ember/test-waiters';
import Modifier from 'ember-modifier';
import type { AnimationItem } from 'lottie-web';

interface LottieAnimationSignature {
  Args: {
    Positional: [path: string, loop?: boolean];
  };
  Element: HTMLElement;
}

function cleanup(instance: LottieAnimationModifier): void {
  const { animation } = instance;
  animation?.destroy();
}

export default class LottieAnimationModifier extends Modifier<LottieAnimationSignature> {
  animation?: AnimationItem;

  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  async modify(
    element: LottieAnimationSignature['Element'],
    [path, loop = true]: LottieAnimationSignature['Args']['Positional'],
  ): Promise<void> {
    const { default: lottie } = await waitForPromise(import('lottie-web'));

    this.animation = lottie.loadAnimation({
      container: element,
      renderer: 'svg',
      loop,
      autoplay: true,
      path,
    });

    registerDestructor(this, cleanup);
  }
}
